

import Attachment from "../../../components/drag_and_drop/Attachment/Attachment.vue";
import { loadingOverlay } from "vuetify-more-component";
import * as XLSX from 'xlsx';

export default {
  components: {
    Attachment,
    loadingOverlay
  },

  data() {
    return {
      items: [
        { tab: 'SUSCRIPCIONES', content: 'man_sus' },
        { tab: 'TIPO REGISTRO', content: 'man_reg' },
        { tab: 'TIPO EMISOR', content: 'man_ros' },
        { tab: 'EMISOR', content: 'man_emi' },
        { tab: 'ACTIVIDAD ECONOMICA', content: 'man_eco' },
        { tab: 'PERFIL DECLARACION', content: 'man_dec' },
        { tab: 'TIPO DTE', content: 'man_dte' },
        { tab: 'Límite ISR', content: 'man_isr' },
        { tab: 'Límite IVA', content: 'man_iva' },
      ],
      tab: null,
      carga_tipo_emisor: false,
      search: '',
      columnasSuscripciones: [
        {
          text: 'Nombre',
          align: 'start',
          sortable: true,
          value: 'nombre',
        },
        {
          text: 'Descripción',
          align: 'start',
          sortable: true,
          value: 'descripcion',
        },
        {
          text: 'Precio',
          align: 'start',
          sortable: true,
          value: 'precio',
        },
        {
          text: 'Modificar',
          align: 'start',
          sortable: false,
          value: 'acciones',
        },
      ],
      listadoSuscripcion: [],
      dialogSuscripciones: false,
      item_aux: null,
      conf_precio: {
        value: "1234567.89",
        label: "Precio de la suscripción",
        readonly: false,
        disabled: false,
        outlined: false,
        clearable: false,
        options: {
          locale: "en-US",
          prefix: "Q. ",
          suffix: "",
          length: 9,
          precision: 2
        },
      },
      loading_suscripcion: false,
      loading_boton_suscripcion: false,
      dialogEmisores: false,
      dialogDelete: false,
      editarEmisores: false,
      columnas_emisores: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "id",
        },
        {
          text: "DESCRIPCION",
          align: "center",
          sortable: true,
          value: "descripcion",
        },
        {
          text: "TIPO REGISTRO",
          align: "center",
          sortable: true,
          value: "tipo_registro.descripcion"
        },
        {
          text: "GRUPO",
          align: "center",
          sortable: true,
          value: "grupo"
        },
        {
          text: "Acciones",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      filas_emisores: [],
      item_aux_emisores: {
        id: null,
        descripcion: '',
        tipo_registro_id: null,
      },
      item_default_emisores: {
        id: null,
        descripcion: '',
        tipo_registro_id: null,
      },
      buscar_emisor: '',
      items_default: [{ text: "SI", value: true }, { text: "NO", value: false }],
      dialogNITEmisores: false,
      dialogNITDelete: false,
      columnas_NITemisores: [
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "NOMBRE",
          align: "center",
          sortable: true,
          value: "nombre"
        },
        {
          text: "TIPO EMISOR",
          align: "center",
          sortable: true,
          value: "tipo_emisor.descripcion",
        },
        {
          text: "ACCIONES",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      filas_NITemisores: [],
      item_aux_NITemisores: {
        id: '',
        nombre: '',
        nit: '',
        tipo_emisor_id: '',
        tipo_emisor: '',
      },
      item_default_NITemisores: {},
      buscar_NITemisor: '',
      lodingTipoEmisores: false,
      lodingEmisores: false,
      editarNITEmisores: false,
      dialogCargaMasivaNITEmisor: false,
      loadingCargaMasiva: false,
      loading_tipo_emisores_activos: false,
      filas_tipo_emisores_activos: [],
      columnas_tipo_registro: [
        {
          text: "DESCRIPCION",
          align: "center",
          sortable: true,
          value: "descripcion",
        },
        {
          text: "TITULO FORMULARIO",
          align: "center",
          sortable: true,
          value: "titulo_formulario",
        },
        {
          text: "POSICION EN EL FORMULARIO",
          align: "center",
          sortable: true,
          value: "orden",
        },
        {
          text: "ACCIONES",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      filas_tipo_registro: [],
      loading_tipo_registro: false,
      buscar_tipo_registro: '',
      dialog_tipo_registro: false,
      item_tipo_registro: {
        id: '',
        descripcion: '',
        orden: '',
        titulo_formulario: ''
      },
      default_item_tipo_registro: {
        id: '',
        descripcion: '',
        orden: '',
        titulo_formulario: ''
      },
      editar_tipo_registro: false,
      dialog_delete_tipo_registro: false,
      filas_tipo_registro_activos: [],
      loading_tipo_registro_activos: false,
      columnas_actividad_economica: [
        {
          text: "DESCRIPCION",
          align: "center",
          sortable: true,
          value: "descripcion",
        },
        {
          text: "ACCIONES",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      filas_actividad_economica: [],
      loading_actividad_economica: false,
      buscar_actividad_economica: '',
      dialog_actividad_economica: false,
      item_actividad_economica: {
        id: '',
        descripcion: ''
      },
      default_item_actividad_economica: {
        id: '',
        descripcion: ''
      },
      editar_actividad_economica: false,
      dialog_delete_actividad_economica: false,
      loading_actividad_economica_activos: false,
      filas_actividad_economica_activos: [],
      expanded: [],
      singleExpand: false,
      columnas_perfil_declaracion: [
        {
          text: "ACTIVIDAD ECONOMICA",
          align: "center",
          sortable: true,
          value: "actividad_economica.descripcion",
        },
        { text: '', value: 'data-table-expand' },
      ],
      filas_perfil_declaracion: [],
      loading_perfil_declaracion: false,
      buscar_perfil_declaracion: '',
      dialog_perfil_declaracion: false,
      item_perfil_declaracion: {
        id: '',
        tipo_emisor_id: null,
        actividad_economica_id: null,
        incluir: null,
      },
      default_perfil_declaracion: {
        id: '',
        tipo_emisor_id: null,
        actividad_economica_id: null,
        incluir: null,
      },
      editar_perfil_declaracion: false,
      opciones_incluir: [{ text: "SI", value: 1 }, { text: "NO", value: 0 }],
      dialog_delete_perfil_declaracion: false,
      columnas_tipo_dte: [
        {
          text: "Descripcion",
          align: "center",
          sortable: true,
          value: "descripcion",
        },
        {
          text: "Abreviatura",
          align: "center",
          sortable: true,
          value: "abreviatura",
        },
        {
          text: "Acciones",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      columnas_isr: [
        {
          text: "Mes",
          align: "center",
          sortable: true,
          value: "mes",
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "year",
        },
        {
          text: "Día límite",
          align: "center",
          sortable: true,
          value: "dia_limite",
        },
        {
          text: "Acciones",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      columnas_iva: [
        {
          text: "Mes",
          align: "center",
          sortable: true,
          value: "mes",
        },
        {
          text: "Año",
          align: "center",
          sortable: true,
          value: "year",
        },
        {
          text: "Día límite",
          align: "center",
          sortable: true,
          value: "dia_limite",
        },
        {
          text: "Acciones",
          align: "center",
          sortable: true,
          value: "actions",
        }
      ],
      form: {
        id: -1,
        nombre: '',
        descripcion: '',
        precio: '',
        anual: null,
      },
      deafult_form: {
        id: -1,
        nombre: '',
        descripcion: '',
        precio: '',
        anual: null,
      },
      filas_tipo_dte: [],
      filas_tipo_isr: [],
      filas_tipo_iva: [],
      loading_tipo_dte: false,
      loading_tipo_isr: false,
      loading_tipo_iva: false,
      buscar_tipo_dte: '',
      buscar_tipo_isr: '',
      buscar_tipo_iva: '',
      dialog_tipo_dte: false,
      dialog_tipo_isr: false,
      dialog_tipo_iva: false,
      item_tipo_dte: {
        id: '',
        descripcion: '',
        abreviatura: '',
      },
      default_item_tipo_dte: {
        id: '',
        descripcion: '',
        abreviatura: '',
      },
      editar_tipo_dte: false,
      dialog_delete_dte: false,
      dialogDeleteEmisores: false,
      loading_emisores: false,
      listadoAnual: [{ text: "SI", value: 1 }, { text: "NO", value: 0 }],
      newRecordDate: null, // Fecha del nuevo registro
      newRecordDate_iva: null, // Fecha del nuevo registro
      loading: false, // Estado del spinner
      isSelect: false,
    }
  },

  watch: {
    dialogEmisores(val) {
      console.log("dialogEmisores", val);
      val || this.cerrarModalEmisores()
    },
    dialogNITEmisores(val) {
      console.log("dialogNITEmisores", val);
      val || this.cerrarModalNITEmisores()
    },
    dialog_tipo_registro(val) {
      console.log("dialog_tipo_registro", val);
      val || this.cerrarModal_tipo_registro();
    },
    dialog_actividad_economica(val) {
      console.log("dialog_actividad_economica", val);
      val || this.cerrarModal_actividad_economica();
    },
    dialog_perfil_declaracion(val) {
      console.log("dialog_perfil_declaracion", val);
      val || this.cerrarModal_perfil_declaracion();
    },
    dialog_tipo_dte(val) {
      console.log("dialog_tipo_dte", val);
      val || this.cerrarModal_tipo_dte();
    },
    dialog_tipo_isr(val) {
      console.log("dialog_tipo_isr", val);
      val || this.cerrarModal_tipo_isr();
    },
    dialog_tipo_iva(val) {
      console.log("dialog_tipo_iva", val);
      val || this.cerrarModal_tipo_iva();
    },
    dialogDelete(val) {
      console.log("dialogDelete", val);
      val || this.cerrarModalEmisores();
    },
  },

  async created() {
    console.log("/man_ros.0");
    await this.getTiposSuscripcion();
    // await this.getTipo_registro_listado();
    // await this.getActividad_economica();
    // await this.getTipoEmisor();
    // await this.getTipoEmisor();
    // await this.getEmisores();
    // await this.f_getLimitISR();
    // await this.f_getLimitIVA();
  },

  computed: {
    emisoresTitulo() {
      console.log("emisoresTitulo");
      return this.editarEmisores === false ? 'Crear Emisor' : 'Editar Emisor'
    },
    emisoresNITTitulo() {
      console.log("emisoresNITTitulo");
      return this.editarEmisores === false ? 'Crear NIT - TIPO EMISOR' : 'Editar NIT - TIPO DE EMISOR'
    },
    tipo_registroTitulo() {
      console.log("tipo_registroTitulo");
      return this.editar_tipo_registro === false ? 'Crear Tipo de Registro' : 'Editar Tipo de Registro';
    },
    actividad_economicaTitulo() {
      console.log("actividad_economicaTitulo");
      return this.editar_actividad_economica === false ? 'Crear Actividad Económica' : 'Editar Actividad Económica';
    },
    perfil_declaracionTitulo() {
      console.log("perfil_declaracionTitulo");
      return this.editar_perfil_declaracion === false ? 'Crear Perfil Declaración' : 'Editar Perfil Declaración';
    },
    tipo_dteTitulo() {
      console.log("tipo_dteTitulo");
      return this.editar_tipo_dte === false ? 'Crear tipo DTE de Registro' : 'Editar tipo DTE de Registro';
    },
  },

  methods: {
    async f_getLimitISR() {
      console.log("f_getLimitISR");
      this.loading_tipo_isr = true;
      this.filas_tipo_isr = [];
      try {
        let r = await this.$store.state.services.administradorService.getLimitISR();
        this.filas_tipo_isr = r.data.data;
        this.loading_tipo_isr = false;
      } catch (error) {
        console.error("Error de getLimitISR:", error);
        this.loading_tipo_isr = false;
      }
    },
    async f_postLimitISR() {
      console.log("f_postLimitISR");
      this.loading = true;
      const fecha_select = this.newRecordDate.split('-');
      const formbody = {
        mes: fecha_select[1],
        year: fecha_select[0],
        dia_limite: fecha_select[2]
      }
      try {
        let r = await this.$store.state.services.administradorService.postLimitISR(formbody);
        console.log(r);
        await this.f_getLimitISR();
      } catch (error) {
        this.dialog_tipo_isr = false;
        console.error("Error al obtener el postLimitISR:", error);
      }
      this.loading = false;
      this.dialog_tipo_isr = false;
    },
    async f_deleteLimitISR(id) {
      console.log("f_deleteLimitISR:", id);
      this.loading = true;
      console.log("f_deleteLimitISR:", id);
      try {
        let r = await this.$store.state.services.administradorService.deleteLimitISR(id);
        await this.f_getLimitISR();
      } catch (error) {
        console.error("Error en deleteLimitISR:", error);
      }
      this.loading = false;
    },
    async f_getLimitIVA() {
      console.log("f_getLimitIVA");
      this.loading_tipo_iva = true;
      this.filas_tipo_iva = [];

      try {
        let r = await this.$store.state.services.administradorService.getLimitIVA();
        this.filas_tipo_iva = r.data.data;
        this.loading_tipo_iva = false;
      } catch (error) {
        console.error("Error de getLimitISR:", error);
        this.loading_tipo_iva = false;
      }
    },
    async f_postLimitIVA() {
      console.log("f_postLimitIVA");
      this.loading = true;
      const fecha_select = this.newRecordDate_iva.split('-');
      // console.log('fecha_select:', fecha_select);

      const formbody = {
        mes: fecha_select[1],
        year: fecha_select[0],
        dia_limite: fecha_select[2]
      }
      // console.log("formData", formbody);

      try {
        let r = await this.$store.state.services.administradorService.postLimitIVA(formbody);
        console.log(r);
        await this.f_getLimitIVA();
      } catch (error) {
        this.dialog_tipo_iva = false;
        console.error("Error al obtener el postLimitISR:", error);
      }

      this.loading = false;
      this.dialog_tipo_iva = false;
    },
    async f_deleteLimitIVA(id) {
      console.log("f_deleteLimitIVA:", id);
      this.loading = true;
      try {
        let r = await this.$store.state.services.administradorService.deleteLimitIVA(id);
        await this.f_getLimitIVA();
      } catch (error) {
        console.error("Error en deleteLimitISR:", error);
      }
      this.loading = false;
    },
    async getTiposSuscripcion() {
      console.log("getTiposSuscripcion");
      try {
        this.loading_suscripcion = true;
        let r = await this.$store.state.services.administradorService.getTiposSuscripcion(2);
        this.loading_suscripcion = false;
        this.listadoSuscripcion = r.data.data;
      } catch (error) {
        console.log(error);
        this.loading_suscripcion = false;
        this.$toast.error("No es posible obtener los tipos de suscripcion")
      }
    },
    modificarSuscripcion(item) {
      console.log("modificarSuscripcion", item);
      this.dialogSuscripciones = true;
      this.item_aux = item;
      this.form.id = this.item_aux.id;
      this.form.nombre = this.item_aux.nombre;
      this.form.descripcion = this.item_aux.descripcion;
      this.form.precio = this.item_aux.precio;
      this.form.anual = this.item_aux.anual;
    },
    crearSuscripcion() {
      console.log("crearSuscripcion");
      this.dialogSuscripciones = true;
      this.form.id = 0;
      this.form.descripcion = '';
      this.form.precio = 0;

    },
    async desactivarSuscripcion(item) {
      console.log("desactivarSuscripcion", item);
      try {
        this.loading_boton_suscripcion = true;
        let r = await this.$store.state.services.administradorService.desactivarTipoSuscripcion({ id: item.id });
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
      }
    },
    async confirmarModificarSuscripcion() {
      console.log("confirmarModificarSuscripcion");
      try {
        this.loading_boton_suscripcion = true;
        this.form.regimen_id = 2;
        let r = await this.$store.state.services.administradorService.actualizarTipoSuscripcion(this.form);
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
      }
    },
    async confirmarCrearSuscripcion() {
      console.log("confirmarCrearSuscripcion");
      try {
        this.loading_boton_suscripcion = true;
        this.form.regimen_id = 2;
        let r = await this.$store.state.services.administradorService.insertarTipoSuscripcion(this.form)
        console.log(r);
        this.loading_boton_suscripcion = false;
        this.limpiar_suscripcion();
      } catch (error) {
        console.log(error);
        this.loading_boton_suscripcion = false;
        this.$toast.error("No es posible crear un tipo de suscripción")
      }
    },

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))
    },

    limpiar_suscripcion() {
      this.dialogSuscripciones = false;
      this.item_aux = null;
      this.form = Object.assign({}, this.deafult_form)
      this.getTiposSuscripcion();
    },

    exportar_errores(errores, grupo) {
      let data = XLSX.utils.json_to_sheet(errores)
      const workbook = XLSX.utils.book_new()
      const filename = grupo;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `Errores_Carga_${grupo}.xlsx`)
    },

    exportarExcel(tipo) {

      if (tipo === 'man_reg') {
        let data = XLSX.utils.json_to_sheet(this.filas_tipo_registro)
        const workbook = XLSX.utils.book_new()
        const filename = 'man_tipo_registro';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'man_ros') {
        let data = XLSX.utils.json_to_sheet(this.filas_emisores)
        const workbook = XLSX.utils.book_new()
        const filename = 'tipos_emisores';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'man_emi') {
        let data = XLSX.utils.json_to_sheet(this.filas_NITemisores)
        const workbook = XLSX.utils.book_new()
        const filename = 'nit_emisor';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'man_eco') {
        let data = XLSX.utils.json_to_sheet(this.filas_actividad_economica)
        const workbook = XLSX.utils.book_new()
        const filename = 'Actividad_economica';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'man_dec') {

        let info = [];
        this.filas_perfil_declaracion.forEach(element => {

          let tipo_emisor = element.tipo_emisor;
          let data = {};
          tipo_emisor.forEach(item_emisor => {
            data = {
              ACTIVIDAD_ECONOMICA: element.actividad_economica.descripcion,
              TIPO_EMISOR_ID: item_emisor.tipo_emisor.id,
              TIPO_EMISOR_DESCRIPCION: item_emisor.tipo_emisor.descripcion,
              INCLUIR: item_emisor.incluir
            }
            info.push(data);
          });
        });
        console.log("info");
        console.log(info);
        let data = XLSX.utils.json_to_sheet(info)

        const workbook = XLSX.utils.book_new()
        const filename = 'Perfil_declaracion';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      } else if (tipo === 'man_dte') {
        let data = XLSX.utils.json_to_sheet(this.filas_tipo_dte)
        const workbook = XLSX.utils.book_new()
        const filename = 'Tipo_dte';
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      }

    },
    clickRow(item, event) {
      if (event.isExpanded) {
        const index = this.expanded.findIndex(i => i === item);
        this.expanded = [];
        console.log(index);

      } else {
        const index = this.expanded.findIndex(i => i === item);
        this.expanded = [];
        console.log(index);
        this.expanded.push(item);
      }
    },

    myFunction() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("myInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("myTable");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },

    async seleccionTab(tipo) {
      console.log("seleccionTab", tipo);
      this.isSelect = true;
      if (tipo == 'man_reg') {
        await this.getTipo_registro_listado();
      } else if (tipo == 'man_ros') {
        await this.getTipoEmisor();
      } else if (tipo == 'man_eco') {
        await this.getActividad_economica();
      } else if (tipo == 'man_dec') {
        await this.getPerfil_declaracion();
      } else if (tipo == 'man_dte') {
        await this.getTipo_dte();
      } else if (tipo == 'man_emi') {
        await this.getEmisores(-1);
        await this.getTipoEmisorActivos();
      } else if (tipo == 'man_sus') {
        await this.getTiposSuscripcion();
      } else if (tipo == 'man_isr') {
        await this.f_getLimitISR();
      } else if (tipo == 'man_iva') {
        await this.f_getLimitIVA();
      }
    },

    modifcar_tipo_dte(item) {
      console.log(item);
      this.editar_tipo_dte = true;
      this.item_tipo_dte = Object.assign({}, item)
      this.dialog_tipo_dte = true
    },

    async tipo_dte_insertar_actualizar() {
      if (this.$refs.formTipodte[0].validate()) {
        if (this.editar_tipo_dte === true) {
          console.log("tipo registro creado");
          try {
            this.loading_tipo_dte = true;
            let r = await this.$store.state.services.administradorService.putTipo_dte_actualizar(this.item_tipo_dte);
            console.log("registro insertar", r);
            this.loading_tipo_dte = false;
            this.dialog_tipo_dte = false;
            this.$toast.info("Tipo DTE actualizado");
            await this.getTipo_dte();
          } catch (error) {
            this.dialog_tipo_dte = false;
            this.dialog_delete_dte = false;
            this.loading_tipo_dte = false;
            console.log(error);
            this.$toast.error("No es posible insertar tipo registro")
          }
        } else {
          console.log("tipo registro creado");
          try {
            this.loading_tipo_dte = true;
            let r = await this.$store.state.services.administradorService.postTipo_dte_insertar(this.item_tipo_dte);
            console.log("registro insertar", r);
            this.$toast.success("Tipo DTE creado exitosamente");
            this.loading_tipo_dte = false;
            this.dialog_tipo_dte = false;
            await this.getTipo_dte();
          } catch (error) {
            this.dialog_tipo_dte = false;
            console.log(error);
            this.loading_tipo_dte = false;
            this.$toast.error("No es posible insertar tipo registro")
          }
        }
      }
    },

    delete_tipo_dte(item) {
      this.item_tipo_dte = Object.assign({}, item)
      this.dialog_delete_dte = true
    },

    async confirmar_eliminar_tipo_dte() {
      try {
        this.loading_tipo_dte = true;
        let r = await this.$store.state.services.administradorService.deleteTipo_dte(this.item_tipo_dte);
        console.log(r, "exitos");
        this.$toast.warning("Tipo DTE modificado");
        this.dialog_delete_dte = false;
        this.dialog_tipo_dte = false;
        this.loading_tipo_dte = false;
        this.getTipo_dte();
      } catch (error) {
        this.loading_tipo_dte = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el tipo de dte");
      }
    },

    cerrarModal_tipo_dte() {
      console.log("adios delete");
      this.$nextTick(() => {
        this.item_tipo_dte = Object.assign({}, this.default_item_tipo_dte)
        this.editar_tipo_dte = false
        if (this.$refs.formTipodte != undefined) {
          this.$refs.formTipodte[0].resetValidation();
        }
      })
    },

    cerrarModal_tipo_isr() {
      console.log("se cierra modal para agg registro isr");
    },
    cerrarModal_tipo_iva() {
      console.log("se cierra modal para agg registro iva");
    },

    async getTipo_dte() {
      try {
        this.loading_tipo_dte = true;
        let r = await this.$store.state.services.administradorService.getTipo_dte_listado();
        console.log("tipo dte", r);
        this.filas_tipo_dte = r.data.data;
        this.loading_tipo_dte = false;
      } catch (error) {
        console.log(error);
        this.loading_tipo_dte = false;
        this.$toast.error("No es posible obetener el listado de dte")
      }
    },

    async getPerfil_declaracion() {
      try {
        this.loading_perfil_declaracion = true;
        let r = await this.$store.state.services.administradorService.getPerfil_declaracion();
        console.log("perfiles", r);
        this.filas_perfil_declaracion = r.data.data;
        this.loading_perfil_declaracion = false;
      } catch (error) {
        this.loading_perfil_declaracion = false;
        console.log(error);
        this.$toast.error("No es posible obtener los perfiles de declaracion")
      }
    },

    async modifcar_perfil_declaracion(actividad_economica, data) {
      console.log(actividad_economica, "data", data);
      this.editar_perfil_declaracion = true;
      let item = {
        id: data.perfil_declaracion_id,
        tipo_emisor_id: data.tipo_emisor.id,
        actividad_economica_id: actividad_economica.id,
        incluir: data.incluir,
      }
      this.item_perfil_declaracion = Object.assign({}, item)
      this.dialog_perfil_declaracion = true;
      await this.getTipoEmisorActivos();
    },

    cerrarModal_perfil_declaracion() {
      console.log("adios delete");
      this.$nextTick(() => {
        this.item_perfil_declaracion = Object.assign({}, this.default_perfil_declaracion)
        this.editar_perfil_declaracion = false
        if (this.$refs.formperfilDeclaracion != undefined) {
          this.$refs.formperfilDeclaracion[0].resetValidation();
        }
      })
    },

    async perfil_declaracion_insertar_actualizar() {
      if (this.$refs.formperfilDeclaracion[0].validate()) {
        if (this.editar_perfil_declaracion === true) {
          console.log("tipo registro creado");
          try {
            this.loading_perfil_declaracion = true;
            let r = await this.$store.state.services.administradorService.putPerfil_declaracion(this.item_perfil_declaracion);
            console.log("registro insertar", r);
            this.loading_perfil_declaracion = false;
            if (r.data.data == 0) {
              this.$toast.error(r.data.message);
            } else {
              this.$toast.info("Perfil de declaración actualizado");
            }
            this.loading_perfil_declaracion = false;
            this.dialog_perfil_declaracion = false;
            await this.getPerfil_declaracion();
          } catch (error) {
            this.dialog_perfil_declaracion = false;
            this.loading_perfil_declaracion = false;
            console.log(error);
            this.$toast.error("No es posible insertar tipo registro")
          }
        } else {
          console.log("tipo registro creado");
          try {
            this.loading_perfil_declaracion = true;
            let r = await this.$store.state.services.administradorService.postPerfil_declaracion(this.item_perfil_declaracion);
            console.log("registro insertar", r);

            if (r.data.data == 0) {
              this.$toast.error(r.data.message);
            } else {
              this.$toast.success("Perfil de declaración creado exitosamente");
            }
            this.loading_perfil_declaracion = false;
            this.dialog_perfil_declaracion = false;
            await this.getPerfil_declaracion();
          } catch (error) {
            this.dialog_perfil_declaracion = false;
            console.log(error);
            this.loading_perfil_declaracion = false;
            this.$toast.error("No es posible insertar tipo registro")
          }
        }
      }
    },

    delete_perfil_declaracion(item) {
      console.log(item);
      this.item_perfil_declaracion = Object.assign({}, item)
      this.dialog_delete_perfil_declaracion = true
    },

    async confirmar_eliminar_perfil_declaracion() {
      try {
        this.loading_perfil_declaracion = true;
        let r = await this.$store.state.services.administradorService.deletePerfil_declaracion(this.item_perfil_declaracion);
        console.log(r, "exitos");
        this.$toast.warning("Perfil declaración modificado");
        this.dialog_delete_perfil_declaracion = false;
        this.dialog_perfil_declaracion = false;
        this.loading_perfil_declaracion = false;

        this.getPerfil_declaracion();
      } catch (error) {
        this.loading_perfil_declaracion = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el tipo de dte");
      }
    },

    async getActividad_economica() {
      try {
        this.loading_actividad_economica = true;
        let r = await this.$store.state.services.administradorService.getActividad_economica();
        console.log("actividad economica", r);
        this.loading_actividad_economica = false;
        this.filas_actividad_economica = r.data.data;
      } catch (error) {
        this.loading_actividad_economica = false;
        console.log(error);
        this.$toast.error("Error en la actividad economica")
      }
    },

    async getListadoActividadEconomicaActivos() {
      try {
        this.loading_actividad_economica_activos = true;
        let r = await this.$store.state.services.administradorService.getListadoActividadEconomicaActivos();
        this.filas_actividad_economica_activos = r.data.data;
        this.loading_actividad_economica_activos = false;
      } catch (error) {
        this.loading_actividad_economica_activos = false;
        console.log(error);
        this.$toast.error("No es posible obtener las actividades economicas actvias")
      }
    },

    delete_actividad_economica(item) {
      console.log(item);
      this.item_actividad_economica = Object.assign({}, item)
      this.dialog_delete_actividad_economica = true
    },

    async confirmar_eliminar_actividad_economica() {
      try {
        this.loading_actividad_economica = true;
        let r = await this.$store.state.services.administradorService.deleteActividad_economica(this.item_actividad_economica);
        console.log(r, "exitos");
        if (r.data.data == 0) {
          this.$toast.error(r.data.message);
        } else {
          this.$toast.warning("Actividad Económica modificada");
        }

        this.dialog_delete_actividad_economica = false;
        this.dialog_actividad_economica = false;
        this.loading_actividad_economica = false;
        this.getActividad_economica();
      } catch (error) {
        this.loading_actividad_economica = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el tipo de dte");
      }
    },

    async modificarActividadEconomica(item) {
      this.editar_actividad_economica = true;
      this.item_actividad_economica = Object.assign({}, item)
      this.dialog_actividad_economica = true;
      await this.getListadoActividadEconomicaActivos();
      await this.getTipoEmisorActivos();
    },

    async actividad_economica_insertar_actualizar() {
      if (this.$refs.formActividadEconomica[0].validate()) {
        if (this.editar_actividad_economica === true) {
          console.log("tipo registro creado");
          try {
            this.loading_actividad_economica = true;
            let r = await this.$store.state.services.administradorService.putActividad_economica(this.item_actividad_economica);
            console.log("registro insertar", r);
            this.loading_actividad_economica = false;
            this.$toast.info("Actividad Economica actualizada");
            this.dialog_actividad_economica = false;
            await this.getActividad_economica();
          } catch (error) {
            this.dialog_actividad_economica = false;

            this.loading_actividad_economica = false;
            console.log(error);
            this.$toast.error("No es posible insertar tipo registro")
          }
        } else {
          console.log("tipo registro creado");
          try {
            this.loading_actividad_economica = true;
            let r = await this.$store.state.services.administradorService.postActividad_economica(this.item_actividad_economica);
            console.log("registro insertar", r);
            this.$toast.success("Actividad Economica creada exitosamente");
            this.loading_actividad_economica = false;
            this.dialog_actividad_economica = false;
            await this.getActividad_economica();
          } catch (error) {
            this.dialog_actividad_economica = false;
            console.log(error);
            this.loading_actividad_economica = false;
            this.$toast.error("No es posible insertar tipo registro")
          }
        }
      }
    },

    cerrarModal_actividad_economica() {
      console.log("adios delete");
      this.$nextTick(() => {
        this.item_actividad_economica = Object.assign({}, this.default_item_actividad_economica)
        this.editar_actividad_economica = false
        if (this.$refs.formActividadEconomica != undefined) {
          this.$refs.formActividadEconomica[0].resetValidation();
        }

      })
    },

    modifcar_tipo_registro(item) {
      this.editar_tipo_registro = true;
      this.item_tipo_registro = Object.assign({}, item)
      this.dialog_tipo_registro = true
    },

    async getTipo_registro_listado_activos() {
      try {
        console.log("llego");
        this.loading_tipo_registro_activos = true;
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado_activos();
        console.log("activos", r);
        this.filas_tipo_registro_activos = r.data.data;
        this.loading_tipo_registro_activos = false;
      } catch (error) {
        this.loading_tipo_registro_activos = false;
        console.log(error);
        this.$toast.error("No es posible obtener el listado de registros activos")
      }
    },

    cerrarModal_tipo_registro() {
      console.log("adios delete");

      this.$nextTick(() => {
        this.item_tipo_registro = Object.assign({}, this.default_item_tipo_registro)
        this.editar_tipo_registro = false
        if (this.$refs.formTipoRegistro) {
          this.$refs.formTipoRegistro[0].resetValidation();
        }
      })
    },

    async getTipo_registro_listado() {
      try {
        this.loading_tipo_registro = true;
        let r = await this.$store.state.services.administradorService.getTipo_registro_listado();
        console.log("getTipo_registro_listado", r);
        this.filas_tipo_registro = r.data.data;
        this.loading_tipo_registro = false;
      } catch (error) {
        this.loading_tipo_registro = false;
        console.log(error);
        this.$toast.error("No es posible enviar obtener el listado de registros")
      }
    },

    delete_tipo_registro(item) {
      console.log(item);
      this.item_tipo_registro = Object.assign({}, item)
      this.dialog_delete_tipo_registro = true
    },

    async confirmar_eliminar_tipo_registro() {
      try {
        this.loading_tipo_registro = true;
        let r = await this.$store.state.services.administradorService.deleteTipo_registro(this.item_tipo_registro);
        console.log(r, "exitos");

        if (r.data.data == 0) {
          this.$toast.error(r.data.message)
        } else {
          this.$toast.warning("Tipo registro modificado");
        }
        this.dialog_delete_tipo_registro = false;
        this.dialog_tipo_registro = false;
        this.loading_tipo_registro = false;
        this.getTipo_registro_listado();
      } catch (error) {
        this.loading_tipo_registro = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el tipo de registro");
      }
    },

    async registro_insertar_actualizar() {
      if (this.$refs.formTipoRegistro[0].validate()) {
        if (this.editar_tipo_registro === true) {
          console.log("tipo registro creado");
          try {
            this.loading_tipo_registro = true;
            let r = await this.$store.state.services.administradorService.putTipo_Registro_actualizar(this.item_tipo_registro);
            console.log("registro insertar", r);
            this.loading_tipo_registro = false;
            this.$toast.info("tipo registro actualizado");
            this.dialog_tipo_registro = false;
            await this.getTipo_registro_listado();
          } catch (error) {
            this.dialog_tipo_registro = false;

            this.loading_tipo_registro = true;
            console.log(error);
            this.$toast.error("No es posible insertar tipo registro")
          }
        } else {
          console.log("tipo registro creado");
          try {
            this.loading_tipo_registro = true;
            let r = await this.$store.state.services.administradorService.postTipo_registro_insertar(this.item_tipo_registro);
            console.log("registro insertar", r);
            this.$toast.success("Tipo registro creado exitosamente");
            this.loading_tipo_registro = false;
            this.dialog_tipo_registro = false;
            await this.getTipo_registro_listado();
          } catch (error) {
            this.dialog_tipo_registro = false;
            console.log(error);
            this.loading_tipo_registro = true;
            this.$toast.error("No es posible insertar tipo registro")
          }
        }
      }
    },

    cerrarModalNITEMISOR() {
      this.dialogCargaMasivaNITEmisor = false;
    },

    async getTipoEmisorActivos() {
      try {
        this.loading_tipo_emisores_activos = true;
        let r = await this.$store.state.services.administradorService.getTipoEmisorActivos();
        r.data.data.filter((item) => {
          item.busqueda = (item.grupo === null ? '' : "Grupo:" + item.grupo) + " ( " + item.descripcion + " )";
        })
        // ordernar alfabeticamente por descripcion
        r.data.data.sort((a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });


        this.filas_tipo_emisores_activos = r.data.data;
        this.loading_tipo_emisores_activos = false;
      } catch (error) {
        this.loading_tipo_emisores_activos = false;
        console.log(error);
        this.$toast.erro("No es posible obtener los tipos de emisores activos")
      }
    },

    async getTipoEmisor() {
      try {
        this.lodingTipoEmisores = true;
        let r = await this.$store.state.services.administradorService.getTipoEmisor();
        console.log("getEmisor", r);
        this.filas_emisores = r.data.data;
        this.lodingTipoEmisores = false;
      } catch (error) {
        this.lodingTipoEmisores = false;
        console.log(error);
        this.$toast.error("No es posible listar los tipos de emisor")
      }
    },

    async postTipoEmisor() {
      try {
        this.lodingTipoEmisores = true;
        let r = await this.$store.state.services.administradorService.postTipoEmisor(this.item_aux_emisores);
        console.log(r);
        await this.getTipoEmisor();
        this.$toast.success("Tipo Emisor creado con éxito")
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible crear el tipo de emisor")
      }
    },

    delete_tipo_emisor(item) {
      this.item_aux_emisores = Object.assign({}, item)
      this.dialogDelete = true
    },

    async updateTipoEmisor() {
      try {
        this.lodingTipoEmisores = true;
        let r = await this.$store.state.services.administradorService.updateTipoEmisor(this.item_aux_emisores)
        console.log(r);
        await this.getTipoEmisor();
        await this.$toast.success("Tipo emisor modificado");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible actualizar este tipo de emisor")
      }
    },

    async getEmisores(id) {
      try {
        this.lodingEmisores = true;
        let r = await this.$store.state.services.administradorService.getListadoEmisores(id);
        console.log("emisores", r);
        this.filas_NITemisores = r.data.data;
        this.lodingEmisores = false;
      } catch (error) {
        this.lodingEmisores = false;
        console.log(error);
        this.$toast.error("No es posible obtener los emisores")
      }
    },

    delete_emisores(item) {
      this.item_aux_NITemisores = Object.assign({}, item)
      this.dialogDeleteEmisores = true
    },

    cargarMasiva() {
      console.log("carga masiva");
      this.dialogCargaMasivaNITEmisor = true;
    },

    async confirmarCargaMasiva(datos, errores) {
      console.log("llegaron los datos", datos);
      try {
        this.loadingCargaMasiva = true;

        let r = await this.$store.state.services.administradorService.cargaMasivaEmisoresNIT({ emisores: datos });
        console.log(r);
        this.$toast.success("Archivo cargado con éxito");
        this.$toast.info("Se han creado " + datos.length + " emisores", { timeout: 5000 });
        if (errores.length > 0) {
          this.exportar_errores(errores, this.carga_tipo_emisor.descripcion)
          this.$toast.info("No se insertó " + errores.length + " emisor(es), verficar el grupo del tipo de emisor", { timeout: 5000 });
        }
        this.carga_tipo_emisor = null;

        this.dialogCargaMasivaNITEmisor = false;
        this.loadingCargaMasiva = false;
        this.getTipoEmisor();
        this.getEmisores(-1);

      } catch (error) {
        this.dialogCargaMasivaNITEmisor = false;
        this.loadingCargaMasiva = false;
        console.log(error);
        this.$toast.error("No es posible cargar los datos al servidor")
      }
    },

    async confirmar_eliminar_emisor() {
      try {
        this.loading_emisores = true;
        let r = await this.$store.state.services.administradorService.deleteEmisor(this.item_aux_NITemisores);
        console.log(r, "exitos");

        if (r.data.data == 0) {
          this.$toast.error(r.data.message);
        } else {
          this.$toast.warning("Emisor modificado");
        }
        this.dialogDeleteEmisores = false;
        this.dialogNITEmisores = false;
        this.loading_emisores = false;
        this.getEmisores(-1);
      } catch (error) {
        this.loading_emisores = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el emisor");
      }
    },
    async confirmar_eliminar_tipo_emisor() {
      try {
        this.lodingTipoEmisores = true;
        let r = await this.$store.state.services.administradorService.deleteTipo_emisor(this.item_aux_emisores);
        console.log(r, "exitos");

        if (r.data.data == 0) {
          this.$toast.error(r.data.message);
        } else {
          this.$toast.warning("Tipo Emisor modificado");
        }
        this.dialogDelete = false;
        this.dialogEmisores = false;
        this.lodingTipoEmisores = false;
        this.getTipoEmisor();
      } catch (error) {
        this.lodingTipoEmisores = false;
        console.log(error);
        this.$toast.error("No es posible eliminar el tipo de dte");
      }
    },

    async modificarEmisor(item) {
      this.editarEmisores = true;
      this.item_aux_emisores = Object.assign({}, item)
      this.dialogEmisores = true;
      await this.getTipo_registro_listado_activos();
    },

    modificarNITEmisor(item) {
      this.editarNITEmisores = true;
      this.item_aux_NITemisores = Object.assign({}, item)
      this.dialogNITEmisores = true;
      this.getTipoEmisorActivos();
    },

    deleteEmisor(item) {
      this.item_aux_emisores = Object.assign({}, item)
      this.dialogDelete = true
    },

    closeDelete() {
      console.log("adios delete");
      this.dialogDelete = false
      this.$nextTick(() => {
        this.item_aux_emisores = Object.assign({}, this.item_default_emisores)
        this.editarEmisores = false
      })
    },

    async guardarEmisor() {
      console.log(this.$refs.formEmisor[0].validate());
      console.log(this.editarEmisores, "this.editarEmisores");
      if (this.$refs.formEmisor[0].validate()) {
        if (this.editarEmisores === true) {
          this.lodingTipoEmisores = true;
          await this.updateTipoEmisor();
          this.dialogEmisores = false;
        } else {
          console.log("emisor creado");
          this.lodingTipoEmisores = true;
          await this.postTipoEmisor();
          this.dialogEmisores = false;
        }
      }
    },

    async guardarNITEmisor() {
      console.log(this.$refs.formNITEmisor[0].validate());
      console.log(this.editarNITEmisores, "this.editarEmisores");
      if (this.$refs.formNITEmisor[0].validate()) {
        if (this.editarNITEmisores === true) {
          await this.updateEmisor();
          this.dialogNITEmisores = false;
        } else {
          console.log("emisor creado");
          await this.postEmisor();
          this.dialogNITEmisores = false;
        }
      }
    },

    async postEmisor() {
      try {
        let r = await this.$store.state.services.administradorService.postEmisor({ nit: this.item_aux_NITemisores.nit, nombre: this.item_aux_NITemisores.nombre, tipo_emisor_id: this.item_aux_NITemisores.tipo_emisor_id });
        console.log(r);
        await this.getEmisores(-1);
        this.$toast.success("Emisor creado con éxito")
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible crear el emisor")
      }
    },

    async updateEmisor() {
      try {
        let r = await this.$store.state.services.administradorService.updateEmisor({ id: this.item_aux_NITemisores.id, nit: this.item_aux_NITemisores.nit, nombre: this.item_aux_NITemisores.nombre, tipo_emisor_id: this.item_aux_NITemisores.tipo_emisor_id })
        console.log(r);
        await this.getEmisores(-1);
        await this.$toast.success("Emisor modificado");
      } catch (error) {
        console.log(error);
        this.$toast.error("No es posible actualizar este emisor")
      }
    },

    cerrarModalEmisores() {
      console.log("adios create");
      this.dialogEmisores = false;
      this.$nextTick(() => {
        this.item_aux_emisores = Object.assign({}, this.item_default_emisores)
        this.editarEmisores = false
        if (this.$refs.formEmisor != undefined) {
          this.$refs.formEmisor[0].resetValidation();
        }
      })
    },
    cerrarModalNITEmisores() {
      console.log("adios create");
      this.dialogNITEmisores = false;
      this.$refs.formNITEmisor[0].resetValidation();
      this.$nextTick(() => {
        this.item_aux_NITemisores = Object.assign({}, this.item_default_NITemisores)
        this.editarNITEmisores = false;
      })
    },
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    ROSlimiteISR(items) {
      console.log("ROSlimiteISR", items);
      let info = [];
  
      items.forEach(element => {
        console.log(element);
  
        info.push({ 'Mes': element.mes, 'Año': element.year, 'Día Limite': element.dia_limite });
      });
  
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'Limite_ISR_ROS';
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
    ROSlimiteIVA(items) {
      console.log("ROSlimiteIVA", items);
      let info = [];
  
      items.forEach(element => {
        console.log(element);
  
        info.push({ 'Mes': element.mes, 'Año': element.year, 'Día Limite': element.dia_limite });
      });
  
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'Limite_IVA_ROS';
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
  },
  async mounted() {
    console.log("/man_ros");
    this.newRecordDate = this.getCurrentDate();
    this.newRecordDate_iva = this.getCurrentDate();
  },
}